import { useEffect } from "react";

const SITE = "https://smithstrategicgroup.net";
const DEFAULT_OG =
  "https://customer-assets-jai6qajn.emergentagent.net/job_ssg-coaching/artifacts/wkjgtzkh_ChatGPT%20Image%20Jul%2024%2C%202026%20at%2008_13_27%20PM.png";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(id, data) {
  let el = document.getElementById(id);
  if (data) {
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = id;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
  } else if (el) {
    el.remove();
  }
}

function setRobots(noindex) {
  let el = document.head.querySelector('meta[name="robots"]');
  if (noindex) {
    if (!el) {
      el = document.createElement("meta");
      el.setAttribute("name", "robots");
      document.head.appendChild(el);
    }
    el.setAttribute("content", "noindex, nofollow");
  } else if (el) {
    el.setAttribute("content", "index, follow");
  }
}

/**
 * Per-page SEO. Sets title, description, canonical, Open Graph, Twitter,
 * an optional page-level JSON-LD block, and an optional noindex directive.
 * Client-rendered (React 19).
 */
export function useSeo({ title, description, path = "/", image, jsonLd, noindex = false }) {
  useEffect(() => {
    const url = `${SITE}${path}`;
    const img = image || DEFAULT_OG;

    if (title) document.title = title;
    setMeta("name", "description", description);
    setCanonical(url);
    setRobots(noindex);

    // Open Graph
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "Smith Strategic Group");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", img);

    // Twitter / X
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", img);

    setJsonLd("page-jsonld", jsonLd);

    return () => {
      setJsonLd("page-jsonld", null);
      setRobots(false);
    };
  }, [title, description, path, image, jsonLd, noindex]);
}

export default useSeo;
